<template>
  <f7-page>
    <AtlasMap />
    <!-- <TracksButton /> -->
    <WeatherButton v-if="zoom > 11" />
    <AtlasPois />

    <transition name="fadezoom">
      <div
        v-if="displayStop"
        class="stop-btn"
        @click="end">
        <AtlasIcon
          name="045-stop" />
      </div>
    </transition>

    <f7-fab
      ref="start"
      position="center-bottom"
      slot="fixed"
      morph-to=".toolbar.fab-morph-target"
      @click="clickMain">
      <AtlasIcon
        name="046-play"
        class="fab-icon" />
    </f7-fab>

    <f7-toolbar bottom class="fab-morph-target">
      <f7-link
        v-if="line"
        @click="pause">
        <AtlasIcon name="044-pause" class="fab-icon" />
      </f7-link>
      <f7-link
        v-else
        @click="restart">
        <AtlasIcon name="046-play" class="fab-icon" />
      </f7-link>
      <!-- <f7-link><AtlasIcon name="008-speedometer" class="fab-icon" /></f7-link>
      <f7-link><AtlasIcon name="050-digital-camera" class="fab-icon" /></f7-link>
      <f7-link><AtlasIcon name="005-chat" class="fab-icon" /></f7-link>
      <f7-link><AtlasIcon name="047-team" class="fab-icon" /></f7-link> -->
    </f7-toolbar>

  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AtlasMap from '../modules/AtlasMap'
import WeatherButton from '../modules/AtlasWeather/WeatherButton'
// import TracksButton from '../modules/AtlasTracks/TracksButton'
import AtlasPois from '../modules/AtlasPois'
export default {
  name: 'HomePage',
  components: {
    AtlasMap,
    WeatherButton,
    AtlasPois
    // TracksButton
  },
  computed: {
    ...mapGetters({
      zoom: 'map/zoom',
      setting: 'user/setting'
    }),
    path () {
      return this.setting('path')
    },
    line () {
      return this.setting('line')
    },
    follow () {
      return this.setting('follow')
    },
    displayStop () {
      if (this.path && !this.line) return true
      else return false
    }
  },
  watch: {
    follow (val, old) {
      if (!val && old) {
        setTimeout(() => {
          this.$f7.fab.close(this.$refs.start.$el)
        }, 500)
      }
    }
  },
  methods: {
    ...mapActions({
      saveSetting: 'user/saveSetting',
      save: 'db/save',
      saveLocation: 'db/saveLocation',
      setPosition: 'map/setPosition' // ,
      // setWatchid: 'map/setWatchid',
      // clearWatchid: 'map/clearWatchid'
    }),
    clearWatchid () {
      navigator.geolocation.clearWatch(Window.watchid)
      Window.watchid = null
      delete Window.watchid
    },
    clickMain () {
      if (!this.path) this.start()
      else if (!this.line) this.restart()
      else this.saveSetting({ follow: true })
    },
    start () {
      if ('geolocation' in navigator) {
        // create a new path
        this.save({ db: 'path' }).then(path => {
          this.saveSetting({ path: path.id })
          this.restart(path.id)
        })
      } else {
        this.$f7.notification.create({
          title: 'Erreur',
          text: 'Le service de géolocalisation n\'est pas disponible sur votre terminal.',
          closeTimeout: 3000
        }).open()
      }
    },
    pause () {
      this.clearWatchid()
      this.saveSetting({ line: null, follow: false })
    },
    restart () {
      // remove previous watch
      this.clearWatchid()
      // create new linestring
      const path = this.path
      this.save({ db: 'line', properties: { path, time: [] }, type: 'LineString', coordinates: [] })
        .then(line => {
          // register in localStorage
          this.saveSetting({ line: line.id, path, follow: true })
          // start geolocation
          const opts = {
            enableHighAccuracy: true,
            maximumAge: 30000,
            timeout: 27000
          }
          const _this = this
          function geoSuccess (position) {
            _this.geoSuccess(position)
          }
          function geoError (error) {
            _this.geoError(error)
          }
          // const watchid = navigator.geolocation
          //   .watchPosition(this.geoSuccess, this.geoError, opts)
          // this.setWatchid(watchid)
          Window.watchid = navigator.geolocation
            .watchPosition(geoSuccess, geoError, opts)
        })
    },
    end () {
      this.$f7.dialog.confirm('Votre parcours sera archivé avec ses photos et conversations.', 'Terminer le parcours', () => {
        this.saveSetting({ follow: false, path: null, line: null })
        this.$f7.fab.close(this.$refs.start.$el)
        // TODO: add end date to the path
      }, () => {
        this.restart()
        this.$f7.fab.open(this.$refs.start.$el)
      })
    },
    geoSuccess (position) {
      const line = this.line
      const pos = {
        coords: {
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.setPosition(pos)
      this.saveLocation({ pos, line }).then(res => {
        console.log(res)
      })
    },
    geoError (err) {
      let text = 'Une erreur inconnue est survenue.'
      switch (err.code) {
        case err.PERMISSION_DENIED:
          text = 'Vous n\'avez pas accepté la géolicalisation.'
          break
        case err.POSITION_UNAVAILABLE:
          text = 'La géolocalisation n\'est pas disponible.'
          break
        case err.TIMEOUT:
          text = 'La géolocalisation a prit trop de temps.'
          break
        // case error.UNKNOWN_ERROR:
        //   break
      }
      if (err.PERMISSION_DENIED) {
        this.clearWatchid()
        this.saveSetting({ follow: false, path: null, line: null })
      } else {
        this.saveSetting({ follow: false, line: null })
      }
      setTimeout(() => {
        this.$f7.fab.close(this.$refs.start.$el)
      }, 500)
      this.$f7.notification.create({
        title: 'Erreur',
        text,
        closeTimeout: 3000
      }).open()
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.path && this.line) {
        this.restart()
        setTimeout(() => {
          this.$f7.fab.open(this.$refs.start.$el)
        }, 500)
      }
    })
  }
}
</script>

<style lang="scss">
.stop-btn {
  position: absolute;
  z-index: 100;
  font-size: 50px;
  background: var(--f7-toolbar-link-color, var(--f7-bars-link-color, var(--f7-theme-color)));
  color: white;
  border-radius: 40px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -40px;
  cursor: pointer;
}
</style>
